module.exports = __webpack_public_path__ + "static/shuttleid-tablet-with-driver-0d7dceac92ce5f707079c82ae76af1ab.jpg";